"use strict";Object.defineProperty(exports, "__esModule", {value: true});
//
//
//
//
//
//
//
//
//
//

exports. default = {
  props: {
    deletable: Boolean,
    name: String
  }
};

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ds-basicForm-deleteProperty" }, [
    _vm.deletable
      ? _c("button", {
          attrs: { title: "删除" + _vm.name },
          on: {
            click: function($event) {
              return _vm.$emit("click")
            }
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
